import { render, staticRenderFns } from "./ingredient-consumption.vue?vue&type=template&id=2ab86896&"
import script from "./ingredient-consumption.vue?vue&type=script&lang=js&"
export * from "./ingredient-consumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports